export const VersionDetails = {
    GET_VERSIONDETAILS: "GET_VERSIONDETAILS",
    UPDATE_APPROVEDSUMMARY: "UPDATE_APPROVEDSUMMARY",
    
}
